import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {MERCHANT_TYPE} from '../../constants';
import {CustomSelect} from '../StyledComp';

const SelectType = ({t, onChange, value, ...props}) => {
  const types = Object.values(MERCHANT_TYPE).map(function(value, index) {
    return <option value={value} key={index}>{t(value)}</option>;
  });

  return (
    <CustomSelect
      name="merchantType"
      onChange={onChange}
      value={value}
      absolute
      {...props}>
      <option disabled value={''}>
        {t('merchantTypeTitle')}
      </option>
      {types}
    </CustomSelect>
  );
};

SelectType.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default withTranslation('merchant')(SelectType);
